<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="1"></HeaderRegion>

    <div id="mainPage">
      <!--
        引入商品顶部操作栏
        region用来区分页面调用,我以文件名作为区分
      -->
      <div class="taskDetail-header">
        <TaskDetailHeader ref="taskDetailFrom" region="taskDetail" :missionInfo="missionInfo"></TaskDetailHeader>
      </div>

      <div class="shop-detail">
        <!-- 详情主要部分 -->
        <div class="shop">
          <ShopDetail ref="ShopFrom" region="taskDetail" :missionInfo="missionInfo"></ShopDetail>
        </div>

        <!-- 右边侧边栏 -->
        <div class="side-Bar">
          <SideNavigationBar ref="SideFrom"></SideNavigationBar>
        </div>
      </div>
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import TaskDetailHeader from "../../components/taskDetailHeader/taskDetailHeader"; //引入商品顶部操作栏
import SideNavigationBar from "../../components/sideNavigationBar/sideNavigationBar"; //右边侧边栏
import ShopDetail from "../../components/shopDetail/shopDetail";
import config from "../../api/config"; //引入商品详情模块
export default {
  name: "taskDetail",
  components: {
    HeaderRegion,
    BottomRegion,
    TaskDetailHeader,
    SideNavigationBar,
    ShopDetail,
  },
  data() {
    return {
      id:0,
      missionInfo:""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getTaskDetail(this.id);
  },
  methods: {
    //获取任务详情
    async getTaskDetail(id) {
      try {
        let data = {
          id: id,
        }
        const res = await this.$http.gettaskdetails(data)
        if (res.code == 200) {
          if(res.result){
            let result = res.result;
            result.squarePicture = result.squarePicture.indexOf("http") > -1 || result.squarePicture.indexOf("https") > -1 ? result.squarePicture : config.baseImgUrl + result.squarePicture
          }
          this.missionInfo = res.result
        } else {
          // this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    }
  },
};
</script>


<style scoped>
.container {
  width: 100%;
}
.taskDetail-header {
  width: 62%;
  padding: 27px 19%;
  background: #ffffff;
}
.shop-detail {
  width: 62%;
  padding: 27px 19%;
  display: flex;
  align-items: flex-start;
}
.side-Bar {
  display: inline-block;
  width: 21.5%;
  margin: 0 0 0 3.5%;
}
.shop {
  width: 75%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskDetail.vue